import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import LPContainer from '../LandingPage/LPContainer'

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    className="w-full h-full">
    <line
      x1="20.5"
      y1="2.18556e-08"
      x2="20.5"
      y2="20"
      stroke="#EDF0F4"
      stroke-dasharray="4 4"
    />
    <line y1="20.5" x2="20" y2="20.5" stroke="#EDF0F4" stroke-dasharray="4 4" />
    <line
      y1="-0.5"
      x2="13"
      y2="-0.5"
      transform="matrix(-1 0 0 1 27 21)"
      stroke="#9CA3AF"
    />
    <line
      y1="-0.5"
      x2="13"
      y2="-0.5"
      transform="matrix(4.37114e-08 1 1 -4.37114e-08 21 14)"
      stroke="#9CA3AF"
    />
  </svg>
)

const OpportunitiesSection: FC = () => {
  const { t } = useTranslation()

  return (
    <div className="relative bg-white">
      <LPContainer>
        <div className="tablet:border-l tablet:border-r border-gray-100 pt-[80px] tablet:pt-24 desktop:pt-32">
          <div className="mx-auto relative">
            {/* Mobile Version */}
            <div className="tablet:hidden">
              <h2 className="font-heading text-[37px] font-semibold leading-[42px] text-gray-900 text-center">
                Spot high-impact
                <br />
                opportunities
                <br />
                instantly
              </h2>
            </div>
            <p className="tablet:hidden tablet:max-w-[804px] text-[16px] text-gray-700 text-center mb-8 mx-auto mt-4">
              {t('lp:talent_ai:opportunities:subtitle')}
            </p>
            {/* Desktop/Tablet Version */}
            <div className="hidden tablet:block">
              <h2 className="text-3xl tablet:text-[37px] tablet:leading-[42px] font-semibold text-gray-900 text-center mb-4">
                {t('lp:talent_ai:opportunities:title')}
              </h2>
              <p className="hidden tablet:block tablet:max-w-[804px] text-[16px] text-gray-700 text-center mb-[42px] mx-auto">
                {t('lp:talent_ai:opportunities:subtitle')}
              </p>
            </div>

            <div className="grid tablet:grid-cols-2 gap-6 tablet:gap-0 mt-12 tablet:border-y tablet:border-gray-100 relative tablet:after:content-[''] tablet:after:absolute tablet:after:left-1/2 tablet:after:top-0 tablet:after:bottom-0 tablet:after:w-px tablet:after:bg-gray-100 tablet:after:-translate-x-1/2 tablet:before:content-[''] tablet:before:absolute tablet:before:left-0 tablet:before:right-0 tablet:before:top-1/2 tablet:before:h-px tablet:before:bg-gray-100 tablet:before:-translate-y-1/2">
              {/* Cross at top-left */}
              <div className="hidden tablet:block absolute top-0 left-0 w-[27px] h-[27px] -translate-x-[20px] -translate-y-[21px] z-10">
                <PlusIcon />
              </div>
              {/* Cross at top-right */}
              <div className="hidden tablet:block absolute top-0 right-0 w-[27px] h-[27px] translate-x-[20px] -translate-y-[21px] z-10">
                <div className="scale-x-[-1]">
                  <PlusIcon />
                </div>
              </div>
              {/* Cross at bottom-left */}
              <div className="hidden tablet:block absolute bottom-0 left-0 w-[27px] h-[27px] -translate-x-[20px] translate-y-[7px] z-10">
                <PlusIcon />
              </div>
              {/* Cross at bottom-right */}
              <div className="hidden tablet:block absolute bottom-0 right-0 w-[27px] h-[27px] translate-x-[20px] translate-y-[7px] z-10">
                <div className="scale-x-[-1]">
                  <PlusIcon />
                </div>
              </div>
              {/* Discover your next move */}
              <div className="flex flex-col tablet:flex-row overflow-hidden border-b border-gray-100 tablet:border-b-0 pb-6 tablet:pb-0">
                <div className="flex flex-1 flex-col tablet:py-8 tablet:pl-10 items-start justify-center">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 bg-green-100 border border-green-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none">
                        <path
                          d="M10 11.667C11.105 11.667 12.1649 12.1054 12.9463 12.8867C13.7276 13.668 14.1669 14.7281 14.167 15.833V17.5C14.167 17.9602 13.7932 18.333 13.333 18.333C12.8729 18.3328 12.5 17.9601 12.5 17.5V15.833C12.4999 15.1701 12.2363 14.5342 11.7676 14.0654C11.2988 13.5967 10.663 13.333 10 13.333H5C4.33704 13.333 3.70125 13.5967 3.23242 14.0654C2.76366 14.5342 2.50009 15.1701 2.5 15.833V17.5C2.5 17.9601 2.12708 18.3328 1.66699 18.333C1.20675 18.333 0.833008 17.9602 0.833008 17.5V15.833C0.833094 14.7281 1.27239 13.668 2.05371 12.8867C2.8351 12.1054 3.89501 11.667 5 11.667H10ZM15.0264 12.4004C15.1414 11.9548 15.5964 11.6867 16.042 11.8018C16.9357 12.0326 17.7274 12.5537 18.293 13.2832C18.8586 14.0128 19.1663 14.9098 19.167 15.833V17.5C19.167 17.9602 18.7932 18.333 18.333 18.333C17.8729 18.3328 17.5 17.9601 17.5 17.5V15.834C17.4995 15.2802 17.3149 14.7414 16.9756 14.3037C16.6362 13.8661 16.1612 13.5535 15.625 13.415C15.1795 13.3 14.9116 12.8459 15.0264 12.4004ZM7.5 1.66699C9.80108 1.66699 11.6668 3.53197 11.667 5.83301C11.667 8.13419 9.80119 10 7.5 10C5.19881 10 3.33301 8.13419 3.33301 5.83301C3.33318 3.53197 5.19892 1.66699 7.5 1.66699ZM12.5264 2.40137C12.6407 1.95573 13.0943 1.68669 13.54 1.80078C14.4362 2.03023 15.2306 2.55155 15.7979 3.28223C16.3651 4.01307 16.6729 4.91271 16.6729 5.83789C16.6728 6.76293 16.3651 7.66184 15.7979 8.39258C15.2306 9.12332 14.4362 9.64456 13.54 9.87402C13.0942 9.98816 12.6406 9.7192 12.5264 9.27344C12.4122 8.82758 12.6811 8.37392 13.127 8.25977C13.6646 8.12205 14.1411 7.80857 14.4814 7.37012C14.8216 6.93175 15.0068 6.39277 15.0068 5.83789C15.0068 5.28282 14.8218 4.74318 14.4814 4.30469C14.1412 3.86629 13.6646 3.55376 13.127 3.41602C12.6811 3.30186 12.4122 2.84722 12.5264 2.40137ZM7.5 3.33301C6.1194 3.33301 5.00018 4.45245 5 5.83301C5 7.21372 6.11929 8.33301 7.5 8.33301C8.88071 8.33301 10 7.21372 10 5.83301C9.99982 4.45245 8.8806 3.33301 7.5 3.33301Z"
                          fill="#3A6F59"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {t('lp:talent_ai:opportunities:discover:title')}
                    </h3>
                  </div>
                  <p className="text-base text-gray-900">
                    {t('lp:talent_ai:opportunities:discover:description')}
                  </p>
                </div>
                <div className="tablet:w-[264px] mx-auto">
                  <picture>
                    <source
                      media="(min-width: 768px)"
                      srcSet="/img/feature/lp/d-oppo.png"
                    />
                    <source
                      media="(max-width: 767px)"
                      srcSet="/img/feature/lp/m-oppo.png"
                    />
                    <img alt="Discover your next move" loading="lazy" />
                  </picture>
                </div>
              </div>

              {/* Build stronger teams */}
              <div className="flex flex-col tablet:flex-row tablet:flex-row-reverse overflow-hidden border-b border-gray-100 tablet:border-b-0 pb-6 tablet:pb-0">
                <div className="flex flex-1 flex-col tablet:py-8 items-start justify-center">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 bg-blue-100 border border-blue-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none">
                        <path
                          d="M10 11.667C11.105 11.667 12.1649 12.1054 12.9463 12.8867C13.7276 13.668 14.1669 14.7281 14.167 15.833V17.5C14.167 17.9602 13.7932 18.333 13.333 18.333C12.8729 18.3328 12.5 17.9601 12.5 17.5V15.833C12.4999 15.1701 12.2363 14.5342 11.7676 14.0654C11.2988 13.5967 10.663 13.333 10 13.333H5C4.33704 13.333 3.70125 13.5967 3.23242 14.0654C2.76366 14.5342 2.50009 15.1701 2.5 15.833V17.5C2.5 17.9601 2.12708 18.3328 1.66699 18.333C1.20675 18.333 0.833008 17.9602 0.833008 17.5V15.833C0.833094 14.7281 1.27239 13.668 2.05371 12.8867C2.8351 12.1054 3.89501 11.667 5 11.667H10ZM15.833 5.83301C16.2932 5.83301 16.667 6.20676 16.667 6.66699V6.81152C16.9592 6.91495 17.2262 7.07005 17.457 7.26758L17.585 7.19434C17.984 6.96513 18.4934 7.10297 18.7227 7.50195C18.9516 7.90092 18.8139 8.41041 18.415 8.63965L18.2891 8.71094C18.3163 8.85886 18.333 9.01117 18.333 9.16699C18.333 9.32259 18.3163 9.47435 18.2891 9.62207L18.415 9.69434C18.8141 9.92366 18.952 10.433 18.7227 10.832C18.4934 11.2309 17.9839 11.3687 17.585 11.1396L17.4561 11.0654C17.2254 11.2627 16.9588 11.4171 16.667 11.5205V11.667C16.6668 12.1271 16.2931 12.5 15.833 12.5C15.373 12.4998 15.0002 12.127 15 11.667V11.5205C14.7079 11.4171 14.4407 11.2629 14.21 11.0654L14.082 11.1396C13.6831 11.3688 13.1737 11.2309 12.9443 10.832C12.715 10.433 12.8529 9.92366 13.252 9.69434L13.376 9.62207C13.3488 9.47444 13.333 9.32248 13.333 9.16699C13.333 9.01128 13.3487 8.85877 13.376 8.71094L13.252 8.63965C12.853 8.41038 12.7153 7.90094 12.9443 7.50195C13.1737 7.10292 13.683 6.96501 14.082 7.19434L14.209 7.26758C14.44 7.06984 14.7076 6.915 15 6.81152V6.66699C15 6.20686 15.3729 5.83318 15.833 5.83301ZM7.5 1.66699C9.80108 1.66699 11.6668 3.53197 11.667 5.83301C11.667 8.13419 9.80119 10 7.5 10C5.19881 10 3.33301 8.13419 3.33301 5.83301C3.33318 3.53197 5.19892 1.66699 7.5 1.66699ZM15.833 8.33301C15.5297 8.33312 15.2648 8.49594 15.1191 8.73828C15.1173 8.7416 15.1162 8.74572 15.1143 8.74902C15.1102 8.75616 15.1049 8.76256 15.1006 8.76953C15.0365 8.8876 15 9.02319 15 9.16699C15.0001 9.3101 15.036 9.44486 15.0996 9.5625C15.1043 9.57004 15.1098 9.57723 15.1143 9.58496C15.115 9.58622 15.1155 9.5876 15.1162 9.58887C15.2611 9.83445 15.5273 9.99988 15.833 10C16.139 10 16.4059 9.83461 16.5508 9.58887C16.5515 9.58761 16.552 9.58622 16.5527 9.58496C16.5571 9.57733 16.5618 9.56994 16.5664 9.5625C16.6301 9.4448 16.6669 9.31021 16.667 9.16699C16.667 9.02325 16.6305 8.88756 16.5664 8.76953C16.5621 8.76256 16.5568 8.75616 16.5527 8.74902C16.5508 8.74563 16.5488 8.74169 16.5469 8.73828C16.4011 8.49602 16.1363 8.33301 15.833 8.33301ZM7.5 3.33301C6.1194 3.33301 5.00018 4.45245 5 5.83301C5 7.21372 6.11929 8.33301 7.5 8.33301C8.88071 8.33301 10 7.21372 10 5.83301C9.99982 4.45245 8.8806 3.33301 7.5 3.33301Z"
                          fill="#274199"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {t('lp:talent_ai:opportunities:teams:title')}
                    </h3>
                  </div>
                  <p className="text-base text-gray-900 tablet:pr-10">
                    {t('lp:talent_ai:opportunities:teams:description')}
                  </p>
                </div>
                <div className="tablet:w-[264px] mx-auto">
                  <picture>
                    <source
                      media="(min-width: 768px)"
                      srcSet="/img/feature/lp/d-teams.png"
                    />
                    <source
                      media="(max-width: 767px)"
                      srcSet="/img/feature/lp/m-teams.png"
                    />
                    <img alt="Discover your next move" loading="lazy" />
                  </picture>
                </div>
              </div>

              {/* Accelerate talent placement */}
              <div className="flex flex-col tablet:flex-row overflow-hidden border-b border-gray-100 tablet:border-b-0 pb-6 tablet:pb-0">
                <div className="flex flex-1 flex-col tablet:py-8 tablet:pl-10 items-start justify-center">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 bg-purple-100 border border-purple-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none">
                        <path
                          d="M11.667 1.66699C12.3298 1.66708 12.9658 1.92977 13.4346 2.39844C13.9034 2.86728 14.167 3.50395 14.167 4.16699V5H16.667C18.0476 5.00018 19.167 6.1194 19.167 7.5V15.833C19.167 17.2136 18.0476 18.3328 16.667 18.333H3.33301C1.95245 18.3328 0.833008 17.2136 0.833008 15.833V7.5C0.833008 6.1194 1.95245 5.00018 3.33301 5H5.83301V4.16699C5.83301 3.50395 6.09659 2.86728 6.56543 2.39844C7.03418 1.92977 7.67016 1.66708 8.33301 1.66699H11.667ZM14.167 16.667H16.667C17.1271 16.6668 17.5 16.2931 17.5 15.833V7.5C17.5 7.03987 17.1271 6.66717 16.667 6.66699H14.167V16.667ZM7.5 16.667H12.5V6.66699H7.5V16.667ZM3.33301 6.66699C2.87292 6.66717 2.5 7.03987 2.5 7.5V15.833C2.5 16.2931 2.87292 16.6668 3.33301 16.667H5.83301V6.66699H3.33301ZM8.33301 3.33301C8.11219 3.33309 7.90033 3.42105 7.74414 3.57715C7.58786 3.73343 7.5 3.94598 7.5 4.16699V5H12.5V4.16699C12.5 3.94598 12.4121 3.73343 12.2559 3.57715C12.0997 3.42105 11.8878 3.33309 11.667 3.33301H8.33301Z"
                          fill="#50408D"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {t('lp:talent_ai:opportunities:placement:title')}
                    </h3>
                  </div>
                  <p className="text-base text-gray-900">
                    {t('lp:talent_ai:opportunities:placement:description')}
                  </p>
                </div>
                <div className="tablet:w-[264px] mx-auto">
                  <picture>
                    <source
                      media="(min-width: 768px)"
                      srcSet="/img/feature/lp/d-placement.png"
                    />
                    <source
                      media="(max-width: 767px)"
                      srcSet="/img/feature/lp/m-placement.png"
                    />
                    <img alt="Discover your next move" loading="lazy" />
                  </picture>
                </div>
              </div>

              {/* Workforce strategy */}
              <div className="flex flex-col tablet:flex-row-reverse rounded-xl overflow-hidden">
                <div className="flex flex-1 flex-col tablet:py-8 items-start justify-center">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 bg-[#FFE8DA] border border-orange-200 rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none">
                        <path
                          d="M18.333 5C18.7931 5 19.1668 5.37292 19.167 5.83301V10.833C19.167 11.2932 18.7932 11.667 18.333 11.667C17.8728 11.6669 17.5 11.2932 17.5 10.833V7.84473L11.8389 13.5059C11.5134 13.8312 10.9856 13.8313 10.6602 13.5059L7.08301 9.92871L2.25586 14.7559C1.93042 15.0813 1.40259 15.0813 1.07715 14.7559C0.751823 14.4304 0.751749 13.9025 1.07715 13.5771L6.49414 8.16113C6.81958 7.8357 7.34741 7.8357 7.67285 8.16113L11.25 11.7383L16.3213 6.66699H13.333C12.8728 6.6669 12.5 6.29319 12.5 5.83301C12.5002 5.37298 12.873 5.00009 13.333 5H18.333Z"
                          fill="#764D36"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {t('lp:talent_ai:opportunities:strategy:title')}
                    </h3>
                  </div>
                  <p className="text-base text-gray-900 tablet:pr-10">
                    {t('lp:talent_ai:opportunities:strategy:description')}
                  </p>
                </div>
                <div className="tablet:w-[264px] mx-auto">
                  <picture>
                    <source
                      media="(min-width: 768px)"
                      srcSet="/img/feature/lp/d-strategy.png"
                    />
                    <source
                      media="(max-width: 767px)"
                      srcSet="/img/feature/lp/m-strategy.png"
                    />
                    <img alt="Discover your next move" loading="lazy" />
                  </picture>
                </div>
              </div>
            </div>
            {/* Gray section below */}
          </div>
        </div>
      </LPContainer>
      <div className="border-b border-gray-100">
        <LPContainer>
          <div className="hidden bg-gray-50 tablet:block tablet:h-[103px]"></div>
        </LPContainer>
      </div>
    </div>
  )
}

export default OpportunitiesSection
